// Module
var code = `<span tabindex="0" role="separator" ng-click="\$ctrl.clicked()" aria-grabbed="{{\$ctrl.grabbed}}" aria-orientation="{{\$ctrl.bgSplitterController.getOrientation()}}" class="handle-grip"><i class="activity-card-drag-handle ficon-app-drag-drop"></i> </span><span class="accessibility-text" aria-live="polite"></span>`;
// Exports
export default code;